// Default flipped from 'staging' to 'production' — staging decommissioned. Revert when staging is back up.
function appstate(state ={isLoading: false, environment: 'production'}, action) {
    switch (action.type) {
      case 'SET_APP_ENV':
        // console.log('set env! : ', action);
        return {
          ...state,
          environment: action.data.environment
        }
      default:
        return state
    }
  }

export default appstate